module.exports = __webpack_public_path__ + "static/media/anger-face.9092e917.png";